module.exports = __webpack_public_path__ + "img/hazardous-material.aaeef959.svg";